"use client";

import { useTranslations } from "next-intl";
import { useFormStatus } from "react-dom";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";

interface SubmitProps {
  error: boolean;
}

export function SubmitButton({ error }: SubmitProps) {
  const { pending } = useFormStatus();
  const t = useTranslations();

  return (
    <Button
      {...(error && { customClass: "!bg-status-error !text-white !border-none" })}
      type="submit"
      size={ButtonSize.SMALL}
      variant={ButtonVariant.PRIMARY}
      theme={ButtonTheme.WHITE}
      disabled={pending}
    >
      {t("button.label.submit")}
    </Button>
  );
}
